import { AmbientpauseIcon, DictateMic } from 'src/icons';
import { endStream } from '../../utils/listen';
import { useAuth, useFeatureEntitlements } from '@frontegg/react';
import MicrophoneBarExpandIcon from 'src/icons/MicrophoneBarExpand.icon';
import { analytics } from 'src/services';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { completeEncounter } from '../../store/actions/encounter';
import {
  selectIsTranscriptTimeout,
  selectMicLevel,
  setMicLevel,
} from 'src/store/slices/microphone.slice';
import { MicrophoneLevel } from '../baseComponents/MicrophoneLevel';
import GenerateSummaryVoiceBar from '../baseComponents/GenerateSummaryVoiceBar';

const MicrophoneBar = ({
  setActiveButton,
  currentActive,
  isRecording,
  setIsRecording,
  setIsStreaming,
  schedulepage = false,
  encounterPhase,
  setShowSaveDeleteButtons,
  selectedRecord,
  storedParams,
  setRecord,
  setEncounterStatus,
  setActiveRightPanelTab,
}) => {
  const { user } = useAuth();
  const micLevel = useSelector(selectMicLevel);
  const isTranscriptTimeout = useSelector(selectIsTranscriptTimeout);
  const dispatch = useDispatch();
  const { mobileViewStatus } = useSelector((state) => state?.encounterState);
  const record =
    selectedRecord !== undefined ? selectedRecord : mobileViewStatus;

  const { isEntitled: hasICD10Access } = useFeatureEntitlements('icd-10');
  const noteType = currentActive === 'Pre-chart' ? 'Pre-chart' : 'In-visit';

  const handlePauseRecording = () => {
    setIsRecording(false);
    setIsStreaming(false);
    dispatch(setMicLevel(0));
    endStream();
    const noteType =
      currentActive === 'Pre-chart' ? 'Pre-chart' : 'after-visit';

    analytics.track(
      `Clicked Pause ${noteType} In Ambient From ${schedulepage ? 'VCA' : 'Aura'}`,
      {
        email: user?.email,
      }
    );
  };

  const handlePauseResumeToggle = () => {
    if (isRecording) {
      console.log('isRecordingMicro', isRecording);
      if (schedulepage) {
        analytics.track(
          `Clicked Pause ${noteType} Microphone Bar From VCA at ${encounterPhase}`,
          {
            email: user?.email,
          }
        );
      } else {
        analytics.track(
          `Clicked Pause ${noteType} Microphone Bar From Aura at ${encounterPhase}`,
          {
            email: user?.email,
          }
        );
      }

      handlePauseRecording();
    }
  };

  const currentActiveEncounterPhase =
    currentActive === 'Pre-chart'
      ? 'pre-chart'
      : currentActive === 'Documents'
        ? 'after-visit'
        : 'in-visit';

  const handleCompleteRecording = () => {
    setIsRecording(false);
    setIsStreaming(false);
    dispatch(setMicLevel(0));
    endStream();

    dispatch(
      completeEncounter(
        record?.encounter_id,
        currentActiveEncounterPhase,
        storedParams,
        undefined,
        (newRecord) => {
          setRecord(newRecord);
          setShowSaveDeleteButtons && setShowSaveDeleteButtons(false);
          setEncounterStatus('summary_inprogress');
          if (hasICD10Access && encounterPhase == 'in-visit') {
            setActiveRightPanelTab && setActiveRightPanelTab('icd10');
          }
        }
      )
    );

    if (schedulepage) {
      analytics.track(
        `Clicked Generate ${currentActiveEncounterPhase} From Microphone Bar in VCA`,
        {
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        `Clicked Generate ${currentActiveEncounterPhase} From Microphone Bar`,
        {
          email: user?.email,
        }
      );
    }
  };

  const handleExpandIcon = () => {
    if (schedulepage) {
      analytics.track(
        `Clicked Expand ${noteType} Microphone Bar From VCA at ${encounterPhase}`,
        {
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        `Clicked Expand ${noteType} Microphone Bar From Aura at ${encounterPhase}`,
        {
          email: user?.email,
        }
      );
    }

    currentActive === 'Pre-chart'
      ? setActiveButton('Pre-chart')
      : setActiveButton('In visit');
  };

  return (
    <div className="flex flex-col items-start justify-between  bg-[#F5F5F5]  border rounded-lg">
      <div className=" flex justify-between w-full bg-emerald-500 hover:bg-emerald-600 rounded-t-lg ">
        <span className=" flex items-center justify-center gap-1 text-white text-sm  py-2 px-3  focus:outline-none focus:shadow-outline ">
          <DictateMic className="animate-pulse" isFill={true} />
          <span className="text-sm font-medium">Transcription Active</span>
        </span>
        <span
          className="cursor-pointer flex justify-center items-center mr-2 transition-transform duration-200 hover:scale-150"
          onClick={handleExpandIcon}
        >
          <MicrophoneBarExpandIcon />
        </span>
      </div>

      <div className="flex w-full m-1 items-center">
        <div
          id={'pause_record'}
          className="flex items-center justify-center text-white py-2 pl-2 "
          onClick={handlePauseResumeToggle}
        >
          <span className="mt-0 mr-2 p-2 rounded-full cursor-pointer bg-red-200">
            <AmbientpauseIcon isRedFill={true} />
          </span>
        </div>
        <div className="text-black text-sm font-medium mr-4">
          <span className="text-black text-sm font-medium mr-2 ">Pause</span>
          {currentActive === 'Pre-chart' ? 'pre-charting' : 'in-visit'}
        </div>
      </div>
      <div className="w-full px-2">
        <MicrophoneLevel
          micLevel={micLevel}
          isTranscriptTimeout={isTranscriptTimeout}
        />
      </div>
      <div className="flex items-center w-full">
        <GenerateSummaryVoiceBar
          handleCompleteRecording={handleCompleteRecording}
          className="m-2"
          showTooltip={false}
        />
      </div>
    </div>
  );
};

export default MicrophoneBar;
